import { createStyleSheet } from '@shared-ui/theme'
import { rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet(() => ({
  wrapperHeaderCenter: {
    position: 'absolute',
    alignItems: 'center',
    gap: rh(4),
    zIndex: 0,
    right: 0,
    left: 0,
    pointerEvents: 'box-none',
  },
  headerStyleCenter: {
    maxWidth: '69%',
  },
  actions: {
    minWidth: rw(40),
    minHeight: rw(40),
    zIndex: 1,
  },
  row: {
    alignItems: 'center',
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'space-between',
    minHeight: rh(64),
    paddingVertical: rh(12),
  },
  isInFormSheet: {
    marginTop: 0,
  },
}))
